import React, { useRef, useEffect, useCallback } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { SectionHead } from "../../../../components/SectionHead/SectionHead";
import { LiveEventCard } from "../../../../components/LiveEventCard";
import "./LiveEventsSection.scss";

SwiperCore.use([Navigation]);

const sliderSettings = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  breakpoints: {
    480: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 10,
    },
    1400: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 10,
    },
    1920: {
      slidesPerView: 5,
      slidesPerGroup: 5,
      spaceBetween: 20,
    },
  },
};

export function LiveEventsSection({ data }) {
  const { title, content: events, react_route } = data;
  const slider = useRef();

  function handleResize() {
    const sliderEl = slider.current;
    if (!sliderEl) return;
    const arrowsEl = sliderEl.querySelectorAll(
      ".swiper-button-prev, .swiper-button-next"
    );
    const cardImage = sliderEl.querySelector(
      ".LiveEventCard__inner-image-block"
    );
    const cardImageHeight = cardImage?.clientHeight;

    arrowsEl.forEach((arrow) => {
      arrow.style.height = `${cardImageHeight}px`;
    });
  }

  const sendPrevBtnClickToAnalytics = useCallback(() => {
    window.analytics?.track("button:click", {
      button_name: "swiper-button-prev",
      parent_object_title: "LiveEvents",
    });
  }, []);

  const sendNextBtnClickToAnalytics = useCallback(() => {
    window.analytics?.track("button:click", {
      button_name: "swiper-button-next",
      parent_object_title: "LiveEvents",
    });
  }, []);

  useEffect(() => {
    handleResize();

    const sliderEl = slider.current;
    const arrowLeftEl = sliderEl?.querySelector(".swiper-button-prev");
    const arrowRightEl = sliderEl?.querySelector(".swiper-button-next");

    arrowLeftEl?.addEventListener("click", sendPrevBtnClickToAnalytics);
    arrowRightEl?.addEventListener("click", sendNextBtnClickToAnalytics);

    return () => {
      arrowLeftEl?.removeEventListener("click", sendPrevBtnClickToAnalytics);
      arrowRightEl?.removeEventListener("click", sendNextBtnClickToAnalytics);
    };
  }, [sendNextBtnClickToAnalytics, sendPrevBtnClickToAnalytics]);

  return (
    <div className="LiveEventsSection">
      <SectionHead
        titleUppercase
        title={title}
        action={{
          type: "link",
          children: "Show more",
          route: react_route,
        }}
      />
      <Swiper
        ref={slider}
        {...sliderSettings}
        className="LiveEventsSection__slider"
        onResize={handleResize}
      >
        {events.map((item, idx) => {
          return (
            <SwiperSlide key={item.id || idx}>
              <LiveEventCard item={item} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
